// extracted by css-extract-rspack-plugin
export default {"Button":"TYv4MWpwHT2zdRMW","centerText":"OTkWZ5zpWYMgRYy5","content":"zUvlDNWB6gsbKrsg","buttonChild":"bFvSSq06KsoJYpfS"};